export const addCol = (str: string) =>
  ![":", "?"].includes(str.charAt(str.length - 1)) ? `${str}:` : str;
